var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37_24377)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_37_24377",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 108,
    height: 108
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 0C10.8 0 0 10.8 0 54C0 97.2 10.8 108 54 108C97.2 108 108 97.2 108 54C108 10.8 97.2 0 54 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_37_24377)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "#FFEECE"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    stroke: "black",
    strokeWidth: 0.25,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    stroke: "#414141",
    strokeWidth: 0.25,
    strokeLinejoin: "bevel"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "#102023"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_37_24377)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5333 70.7787V36.9814L36.2893 28.5469L20.75 43.9965V63.994L36.2893 79.5476L49.5333 70.7787Z",
    fill: "#1C8578"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6888 53.5021L87.2498 53.4129V43.9975L67.2389 24H40.8798L36.3008 28.5479L66.6888 53.5021Z",
    fill: "url(#paint0_linear_37_24377)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66.6888 53.5032L36.3008 79.5498L40.7534 84.0011H67.2389L87.2498 63.9962V53.4141L66.6888 53.5032Z",
    fill: "#11A694"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_37_24377",
    x1: 55.6741,
    y1: 27.1327,
    x2: 72.9626,
    y2: 53.0489,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0483,
    stopColor: "#11A694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2FE0C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37_24377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 108,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_37_24377"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.5001,
    height: 60,
    fill: "white",
    transform: "translate(20.75 24)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobileLogo.3a174b8ee05e47c366dbc10be123148f.svg";
export { ForwardRef as ReactComponent };